<template>
  <div>
    <a-modal
      :title="dataForm.id ? '编辑体验信息' : '新增体验信息'"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      :keyboard="false"
      :maskClosable="false"
      @cancel="handleCancel"
      :getContainer="getContainer"
    >
      <a-form-model
        ref="ruleForm"
        :model="dataForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="体验设备名称" prop="name">
          <a-input
            size="large"
            v-model="dataForm.name"
            placeholder="请输入体验设备名称（如某某答题软件）"
          />
        </a-form-model-item>
        <a-form-model-item label="设备编号" prop="device_id">
          <a-input
            size="large"
            v-model="dataForm.device_id"
            placeholder="请输入设备编号"
          >
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-input
            size="large"
            v-model="dataForm.remark"
            placeholder="请输入备注"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
  
<script>
import { addExperience, editExperience, experienceInfo } from "@/request/device";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      dataForm: {
        id: "",
        name: "", //设备名称
        device_id: "", //设备编号
        remark: "",
      },
      bf: {},
      rules: {
        name: [
          { required: true, message: "请输入设备名称", trigger: "change" },
        ],
        device_id: [
          { required: true, message: "请输入设备编号", trigger: "change" },
        ],
      },
    };
  },
  beforeMount() {
    this.bf = JSON.parse(JSON.stringify(this.dataForm));
  },
  methods: {
    init(id = "") {
      this.visible = true;
      if (id) {
        this.dataForm.id = id;
        this.getInfo();
      }
    },
    getInfo() {
      experienceInfo(this.dataForm.id).then((res) => {
        this.dataForm = { ...res.data };
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const fn = this.dataForm.id ? editExperience : addExperience;
          fn(this.dataForm)
            .then((res) => {
              this.$message.success(
                this.dataForm.id ? "修改体验设备成功" : "新增体验设备成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.$refs.ruleForm.resetFields();
      this.dataForm = JSON.parse(JSON.stringify(this.bf));
      this.treeData = [];
      this.visible = false;
    },
    getContainer() {
      return document.getElementById("bodyContnet");
    },
  },
};
</script>
  
<style></style>